import React from "react";
import Sidebar from "../components/sidebar";
import Header from "../components/Header";
import Top from "../components/topselection";

const TopPage = () => {
  return (
    <>
      <Sidebar />
      <main className="main-wrap">
        <Header />
        <Top/>
      </main>
    </>
  );
};

export default TopPage;
